import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const isMiwiEnabledSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('miwiMod'),
)

export default isMiwiEnabledSelector
